const getNextFromUrlSearchParameters = (): string | null => {
  // Extract the next parameter from the URL
  const params = new URLSearchParams(window.location.search);
  return params.get("next");
};

export default getNextFromUrlSearchParameters;
